import { render, staticRenderFns } from "./TaxInvoice.vue?vue&type=template&id=4cd87f4a&scoped=true"
import script from "./TaxInvoice.vue?vue&type=script&lang=js"
export * from "./TaxInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd87f4a",
  null
  
)

export default component.exports